import React, { useState } from 'react'
import { store } from '../../../../store/favor/store'
import { HeaderSearch } from '../../../shared/icon'
import { HeaderComputer } from '../../../shared/header_computer'
import { Observer } from 'mobx-react-lite'
import { MyFavorGroup } from '../components/my_favor_group'

export function Header() {
  const goToMyFavorGroup = () => {
    store.setFavorGroupVisible(true)
    store.setStockScroll('stock-scroll-hidden')
  }

  const gotoFavorManage = () => {
    let title = store.currentFavor?.gname
    let code = store.currentFavor?.gid
    if (title && code) {
      location.href = 'manage.html?id=' + code
      return
    }
  }

  const ellipsisTitle = ()=>{
    if(window.innerWidth < 370){
      if(store.title.length > 5){
        return store.title.substring(0,4)+'...'
      }else{
        return store.title
      }
    }else{
      if(store.title.length > 8){
        return store.title.substring(0,8)+'...'
      }else if(store.title.length > 6){
        return store.title.substring(0,5) +'...'
      }else{
        return store.title
      }
    }
  }

  return (
    <Observer>
      {() => (
        <>
          <div className="comm-header">
            <a
              href="#"
              className="manage"
              onClick={(e) => {
                e.preventDefault()
                gotoFavorManage()
              }}
            >
              管理
            </a>
            <div
              className="favor-title"
              onClick={(e) => {
                e.preventDefault()
                goToMyFavorGroup()
              }}
            >
              <span>{ellipsisTitle()}</span>
              <span className="triangle-down"></span>
            </div>
            <div className="header-comp">
              <HeaderComputer />
              <HeaderSearch />
            </div>
          </div>
          {store.favorGroupVisible && <MyFavorGroup />}
        </>
      )}
    </Observer>
  )
}
